import { FC } from "react";
import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { OptimisticDataImportItem } from "@/pages/settings/components/migration/optimistic-data-import-item";
import { ImportItem } from "@/pages/settings/components/migration/import-item";
import { windowModule } from "@/modules/window";
import { MDSText, MDSTextVariant, MDSLink } from "@/mds";

export const SettingsAccountMigrationV2Section: FC = observer(() => {
  const { store } = useAppStore();

  const anyImportIsRunning = store.dataImports.getLatestImports(3).some(imp => imp.isRunning);
  const shouldShowExtraLoaderIcon = !anyImportIsRunning;

  return (
    <>
      <MDSText variant={MDSTextVariant.ParagraphS}>
        You&apos;ll start seeing your content as it completes the migration process, which may take
        a few minutes; progress is shown below. Please note that shared content will only become
        available after all collaborators have been upgraded to 2.0, so it may take longer to
        appear.
      </MDSText>
      <br />
      <MDSText variant={MDSTextVariant.ParagraphS}>
        Additionally, please note the following changes in Mem 2.0:
      </MDSText>
      <List>
        <li>
          <b>Notes, collections</b>, and <b>templates</b> will migrate as is.
        </li>
        <li>
          <b>Groups</b> will be converted to <b>shared collections</b>.
        </li>
        <li>
          <b>Favorited notes</b> will be converted to <b>pinned notes</b>.
        </li>
        <li>
          <b>Comments</b> will be converted to notes.
        </li>
      </List>
      <p>
        <MDSLink
          onPress={() => {
            windowModule.openInNewTab({
              url: new URL("https://get.mem.ai/blog/mem-2-dot-0-transition-guide"),
            });
          }}
        >
          Learn more in our transition guide.
        </MDSLink>
      </p>
      <ImportsContainer>
        {shouldShowExtraLoaderIcon && <OptimisticDataImportItem />}
        {store.dataImports.getLatestImports(3).map(imp => (
          <ImportItem dataImport={imp} key={imp.id} />
        ))}
      </ImportsContainer>
    </>
  );
});

const ImportsContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  gap: 8,
});

const List = styled.ul`
  margin-left: 0;
  padding-left: 25px;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.colors.text.primary};
`;
